import { Trash2, Loader2Icon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useDeleteTodoVault } from "@/hooks/queries/useDeleteTodoVault";
import { TodoVault } from "@/lib/types";

export function DeleteVaultDialog({
  open,
  onOpenChange,
  vault,
  onDeleteVault,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  vault: TodoVault | null;
  onDeleteVault: () => void;
}) {
  const deleteVault = useDeleteTodoVault();

  const handleDelete = () => {
    if (vault) {
      onDeleteVault();
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Trash2 className="h-5 w-5 text-destructive" />
            <span>Delete Vault</span>
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{vault?.name}"? This action will
            permanently delete all todos in this vault and cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleDelete}
            disabled={deleteVault.isPending}
          >
            {deleteVault.isPending ? (
              <>
                <Loader2Icon className="h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              "Delete Vault"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
